// スクロールで画面下に出す固定要素（固定 CTA・ページ上部へ戻るボタン）: [data-mp-sticky-cta]
//   data-mp-sticky-after="セレクタ"  … この要素が画面の上へ抜けたら表示する
//   data-mp-sticky-hide="セレクタ"   … この要素が画面に見えている間は隠す（同じ内容の CTA との重複を避ける。複数可）
//   data-mp-sticky-until="セレクタ" … この要素が画面に入ったら、それ以降（下まで）は隠す
// 表示中は .is-visible。隠している間は inert にして、フォーカスと読み上げの対象から外す。

function setupStickyCta(bar) {
  // 属性が無いときは探さない（空のセレクタで querySelector を呼ぶと例外になる）
  const find = (selector) => (selector ? document.querySelector(selector) : null);
  const after = find(bar.dataset.mpStickyAfter);
  const hides = bar.dataset.mpStickyHide ? [...document.querySelectorAll(bar.dataset.mpStickyHide)] : [];
  const until = find(bar.dataset.mpStickyUntil);
  if (!after) return;

  let ticking = false;
  const update = () => {
    ticking = false;
    const vh = window.innerHeight;
    const passed = after.getBoundingClientRect().bottom < 0;
    const overlapping = hides.some((el) => {
      const r = el.getBoundingClientRect();
      return r.top < vh && r.bottom > 0;
    });
    const reachedEnd = until ? until.getBoundingClientRect().top < vh : false;
    const show = passed && !overlapping && !reachedEnd;
    bar.classList.toggle('is-visible', show);
    bar.inert = !show;
  };
  const request = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  update();
}

export function setupStickyCtas() {
  document.querySelectorAll('[data-mp-sticky-cta]').forEach(setupStickyCta);
}
